export default __webpack_public_path__ + "static/cladiri-verzi-ed99ba27ae99c6234e12baa27826d1d7.jpg";